__turbopack_context__.v({
  "checkLabel": "login-module__WEZH7G__checkLabel",
  "designStage": "login-module__WEZH7G__designStage",
  "emptyRanking": "login-module__WEZH7G__emptyRanking",
  "emptyRankingText": "login-module__WEZH7G__emptyRankingText",
  "emptySchoolPanel": "login-module__WEZH7G__emptySchoolPanel",
  "error": "login-module__WEZH7G__error",
  "field": "login-module__WEZH7G__field",
  "forgotButton": "login-module__WEZH7G__forgotButton",
  "formOptions": "login-module__WEZH7G__formOptions",
  "hero": "login-module__WEZH7G__hero",
  "loginForm": "login-module__WEZH7G__loginForm",
  "loginPage": "login-module__WEZH7G__loginPage",
  "loginStatus": "login-module__WEZH7G__loginStatus",
  "loginSubmit": "login-module__WEZH7G__loginSubmit",
  "rankList": "login-module__WEZH7G__rankList",
  "rankPanel": "login-module__WEZH7G__rankPanel",
  "ranking": "login-module__WEZH7G__ranking",
  "rankingGrid": "login-module__WEZH7G__rankingGrid",
  "ruleBlock": "login-module__WEZH7G__ruleBlock",
  "rules": "login-module__WEZH7G__rules",
  "rulesCopy": "login-module__WEZH7G__rulesCopy",
  "rulesPanel": "login-module__WEZH7G__rulesPanel",
  "rulesTitleFrame": "login-module__WEZH7G__rulesTitleFrame",
  "schoolLogo": "login-module__WEZH7G__schoolLogo",
  "schoolRanking": "login-module__WEZH7G__schoolRanking",
  "schoolScore": "login-module__WEZH7G__schoolScore",
  "sectionTitleFrame": "login-module__WEZH7G__sectionTitleFrame",
  "skipLink": "login-module__WEZH7G__skipLink",
  "srOnly": "login-module__WEZH7G__srOnly",
  "success": "login-module__WEZH7G__success",
  "termsLabel": "login-module__WEZH7G__termsLabel",
});
